import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function JobTypes({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t(
        'dashboardComponents.Console.RefDataManagement.JobTypes.jobTypeName'
      ),
      field: 'name',
      sortable: true,
    },
    { name: t('common.sortOrder'), field: 'sortOrder', sortable: true },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];
  return (
    <TableView
      setItemCount={setItemCount}
      dataName={t(
        'dashboardComponents.Console.RefDataManagement.JobTypes.jobType'
      )}
      getDataHandler={AdminService.getJobTypes}
      deleteDataHandler={AdminService.deleteJobType}
      createDataHandler={AdminService.createJobType}
      updateDataHandler={AdminService.updateJobType}
      viewLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.JobTypes.jobTypeName'
          ),
          field: 'name',
        },
      ]}
      viewRightColumnFields={[
        { label: t('common.sortOrder'), field: 'sortOrder' },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.RefDataManagement.JobTypes.jobTypeName'
          ),
          field: 'name',
          validation: ['string', 'required', 'alphabets'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.JobTypes.jobTypeNameHere'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.JobTypes.specifySortOrderHere'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.JobTypes.enterAnySpecificNotesAboutTheJobType'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
